

























































import { Vue, Component, Prop } from 'vue-property-decorator';
import { SpecificationViewObject } from '@/types/apiServerContract';
import dictionaryService, { NamedLabelArgument } from '@/core/translation/dictionary.service';

import ReadMore from '@/core/ui-components/ReadMore.vue';

@Component({
    components: { ReadMore }
})
export default class ProductDetailsSpecifications extends Vue {
    @Prop({ required: true, type: Array })
    specifications!: SpecificationViewObject[];

    @Prop({ required: false, type: Object, default: {} })
    metaData!: NamedLabelArgument;

    open() {
        this.$refs.readmore.open();
    }

    close() {
        this.$refs.readmore.close();
    }

    getUnit(unit: string) {
        return dictionaryService.translate(unit);
    }

    get labelSpecifications(): string | null {
        return dictionaryService.getWithNamedValues(
            dictionaryService.exists('Product.Details.Specifications.SpecificationsFor') && this.metaData?.product ? 'Product.Details.Specifications.SpecificationsFor' : 'Product.Details.Specifications',
            this.metaData
        );
    }

    $refs!: {
        readmore: ReadMore;
    };
}
